<template>
  <div>
    <div class="item">
      <div v-for="(systemItem, index) in answerBody.answers.system" :key="index" class="system-wrapper">
        <div v-for="(value, key) in sortedKeys(systemItem.result)" :key="key" class="wrapper">
          <h5 class="legend">{{ formatKey(key) }}</h5>

          <!-- Для простых значений и массивов -->
          <template v-if="!isObject(value) || Array.isArray(value)">
            <p class="question">{{ formatKey(key) }}: <span>{{ formatValue(value) }}</span></p>
          </template>

          <!-- Для объектов -->
          <template v-else>
            <div v-for="(nestedValue, nestedKey) in sortedKeys(value)" :key="nestedKey" class="nested-wrapper">

              <!-- Если вложенное значение тоже объект -->
              <template v-if="isObject(nestedValue) && !Array.isArray(nestedValue)">
                <h6 class="sub-legend">{{ formatKey(nestedKey) }}</h6>
                <div v-for="(deepValue, deepKey) in sortedKeys(nestedValue)" :key="deepKey" class="deep-wrapper">

                  <!-- Если глубоко вложенное значение объект -->
                  <template v-if="isObject(deepValue) && !Array.isArray(deepValue)">
                    <h7 class="deep-legend">{{ formatKey(deepKey) }}</h7>
                    <p v-for="(finalValue, finalKey) in sortedKeys(deepValue)" :key="finalKey" class="question">
                      {{ formatKey(finalKey) }}: <span>{{ formatValue(finalValue) }}</span>
                    </p>
                  </template>

                  <!-- Если глубоко вложенное значение не объект -->
                  <template v-else>
                    <p class="question">
                      {{ formatKey(deepKey) }}: <span>{{ formatValue(deepValue) }}</span>
                    </p>
                  </template>
                </div>
              </template>

              <!-- Если вложенное значение НЕ объект (простое значение) -->
              <template v-else>
                <p class="question">
                  {{ formatKey(nestedKey) }}: <span>{{ formatValue(nestedValue) }}</span>
                </p>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuestionsCallForm",
  props: {
    answerBody: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatKey(key) {
      if (!key) return '';
      return String(key)
        .replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },

    formatValue(value) {
      if (value === null || value === undefined) return 'Не указано';
      if (Array.isArray(value)) return value.join(', ') || 'Не указано';
      if (typeof value === 'object') return 'Объект';
      return value.toString();
    },

    isObject(value) {
      return typeof value === 'object' && value !== null;
    },

    // Сортируем ключи: сначала простые значения, потом объекты
    sortedKeys(obj) {
      if (!obj || typeof obj !== 'object') return {};

      const simpleKeys = [];
      const objectKeys = [];

      Object.keys(obj).forEach(key => {
        const value = obj[key];
        if (this.isObject(value) && !Array.isArray(value)) {
          objectKeys.push(key);
        } else {
          simpleKeys.push(key);
        }
      });

      // Создаем новый объект с отсортированными ключами
      const sortedObj = {};
      [...simpleKeys, ...objectKeys].forEach(key => {
        sortedObj[key] = obj[key];
      });

      return sortedObj;
    }
  },
};
</script>

<style lang="scss" scoped>
.item {
  line-height: 1;
  .system-wrapper {
    margin-bottom: 20px;
    border: 1px solid #ddd;
    padding: 10px;
    border-radius: 5px;

    .wrapper {
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: none;
      }

      .legend {
        font-weight: bold;
        color: #333;
        font-size: 12px;
        margin-bottom: 5px;
        text-decoration: underline;
      }

      .sub-legend {
        font-weight: bold;
        color: #555;
        font-size: 11px;
        margin: 0px 0 3px 0;
        padding-left: 10px;
        border-left: 3px solid #3498db;
      }

      .deep-legend {
        font-weight: bold;
        color: #777;
        font-size: 10px;
        margin: 3px 0 2px 15px;
        padding-left: 8px;
        border-left: 2px solid #e74c3c;
      }

      .nested-wrapper {

        padding-bottom: 5px;
        padding-left: 5px;
        border-left: 1px solid #eee;
      }

      .deep-wrapper {
        margin-left: 10px;
        margin-bottom: 5px;
        padding-left: 8px;
        border-left: 1px dashed #ddd;
      }

      .question {
        color: #555;
        font-size: 10px;
        font-weight: bold;
        margin-bottom: 0px;
        margin-left: 15px;

        span {
          font-weight: normal;
          color: #333;
        }
      }
    }
  }
}
</style>